<!--APP-SIDEBAR-->
<div class="sticky">
  <div class="app-sidebar__overlay" (click)="sidebarClose()"></div>
  <div class="app-sidebar chatSidebar">
    <div class="side-header">
      <a class="header-brand1" routerLink="/">
        <app-logo class="bigLogo"></app-logo>
      </a>
      <a
        aria-label="Hide Sidebar"
        class="app-sidebar__toggle"
        (click)="toggleSidebar($event)"
        aria-label="Open folder"
      >
        <i class="humberger-menu" aria-hidden="true"></i>
      </a>
    </div>

    <!-- LOGO -->

    <div class="main-sidemenu">
      <ul class="sidebar__list">
        <li
          class="sidebar__item fixed-top"
          [ngClass]="{ 'sidebar__item--active': currentUrl() == 'chat' }"
        >
          <a
            class="sidebar__link"
            (click)="toggleSidebarMobile(null)"
            placement="top"
            ngbTooltip="New chat"
            container="body"
            tooltipClass="tooltipNew"
            href="javascript:void(0);"
            [routerLink]="['chat']"
            aria-label="Open folder"
          >
            <span class="sidebar__text">New Chat</span>
            <i class="sidebar__icon" [innerHTML]="ICONS.newChat | safeHtml"> </i>
          </a>
        </li>
      </ul>

      <div class="chatHead">
        <h6>
          <i
            class="sidebar__icon"
            [innerHTML]="ICONS.chats | safeHtml"
            placement="top"
            ngbTooltip="chats"
            container="body"
            tooltipClass="tooltipNew"
          >
          </i>
          <span>Chats</span>
        </h6>
        <div class="chatBtmCol">
          @if (!(menuItems().length == 0 && search() == null)) {
            <div class="searchSidebar searchlarge">
              <input
                type="text"
                class="search-bar__input"
                placeholder="Search chat"
                [(ngModel)]="search"
                (input)="searchInput($event)"
              />
              <i class="searchIcon" [innerHTML]="ICONS.searchIcon | safeHtml"> </i>
            </div>
          }
          <button
            class="common--button searchBtn"
            placement="end"
            [ngbPopover]="popContent"
            [autoClose]="'outside'"
            popoverClass="searchPopover"
            container="body"
          >
            <i class="searchIcn" [innerHTML]="ICONS.searchIcon | safeHtml"> </i>
          </button>
          <ng-template #popContent>
            <div class="searchSidebar searchsmall">
              <input
                type="text"
                class="search-bar__input"
                placeholder="Search chat"
                [(ngModel)]="search"
                (input)="searchInput($event)"
              />
              <i class="searchIcon" [innerHTML]="ICONS.searchIcon | safeHtml"> </i>
            </div>
          </ng-template>

          <div smoothScrollSidebar class="scrollable-items scrollable-itemsList">
            <ul>
              @if (isLoading()) {
                <output class="loader-container loader_top">
                  <div class="spinner-border"></div>
                </output>
              }
              @for (data of filteredChats(); track $index) {
                <li
                  (click)="toggleNavActive(data, $index)"
                  (keyup.enter)="toggleNavActive(data, $index)"
                  class="sidebar__item"
                  [ngClass]="currentUrl() == data.id ? 'sidebar__item--active' : ''"
                >
                  <a
                    class="sidebar__link"
                    (click)="toggleSidebarMobile(data.id)"
                    [ngbTooltip]="data.title"
                    container="body"
                    tooltipClass="tooltipNew"
                    placement="auto"
                    [disableTooltip]="colabe(data)"
                    data-placement="bottom"
                    aria-label="Open folder"
                  >
                    <i class="sidebar__icon" [innerHTML]="ICONS.chatIcon | safeHtml"> </i>

                    @if (editId != data?.id) {
                      <p class="sidebar__text">
                        <span>{{ data.title }}</span>
                        <em>{{ data.timeAgo }}</em>
                      </p>
                    }
                    @if (editId == data?.id) {
                      <div class="update">
                        <input
                          class="edit_box"
                          [(ngModel)]="EditContent"
                          (keyup.enter)="showSubmit(EditContent || '') ? updateName($index) : false"
                          (click)="$event.stopPropagation()"
                        />
                        @if (EditContent) {
                          <button class="cancel-btn" (click)="editId = ''" aria-label="Cancel">
                            <i [innerHTML]="ICONS.closeIcon | safeHtml"> </i>
                          </button>
                        }
                      </div>
                    }

                    <div
                      data-bs-toggle="dropdown"
                      class="dotsIcon"
                      (click)="$event.stopPropagation()"
                      [ngbPopover]="customPop"
                      [placement]="isMobile() ? 'auto' : 'right'"
                      container="body"
                      popoverClass="menuPopover"
                    >
                      <i [innerHTML]="ICONS.threeDotIcon | safeHtml"> </i>
                    </div>

                    <ng-template #customPop>
                      <div class="poplist">
                        @for (action of sessionActions; track $index) {
                          <button
                            class="popMenu"
                            (click)="
                              action.handler(data, $index);
                              action.label === 'Delete' && toggleSidebarMobile(null)
                            "
                          >
                            <span>{{ action.label }}</span>
                          </button>
                        }
                      </div>
                    </ng-template>
                  </a>
                </li>
              }
              @if (filteredChats()?.length == 0 && !isLoading()) {
                <div class="noData">
                  <p>No Chats Found!</p>
                </div>
              }
            </ul>
          </div>

          <div class="fixed-bottom sidebarBtns">
            <div class="user-info" ngbDropdown placement="top-start" #dropdownRef="ngbDropdown">
              <a
                href="javascript:void(0);"
                class="sidebar__link"
                placement="top-left"
                [ngbPopover]="logoutContent"
                popoverClass="logoutPopover"
                container="body"
                aria-label="Open folder"
              >
                <div class="user-avatar">
                  {{ getInitials(user?.name) }}
                </div>
                <span class="sidebar__text">{{ user?.name }}</span>
              </a>

              <ng-template #logoutContent>
                <ul ngbDropdownItem class="viewMoreItem">
                  @if (user?.role != 'User') {
                    <li>
                      <button class="logoutlink p-0" ngbDropdownItem [routerLink]="'/kpi-explorer'">
                        <span [innerHTML]="ICONS.agentIcon | safeHtml"></span>
                        <span>FieldQ Admin</span>
                      </button>
                    </li>
                  }
                  <li>
                    <button
                      class="logoutlink p-0"
                      ngbDropdownItem
                      (click)="logout(); toggleSidebarMobile(null)"
                    >
                      <span [innerHTML]="ICONS.logoutIcon | safeHtml"></span>
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
